export default __webpack_public_path__ + "static/1.1_IT-21bc3ba3cfed2df693481c078e7dc3a4.webp";